import * as $ from 'jquery';
import ViewportTracker from '../../lib/ViewportTracker';

export default class Team {
	constructor() {
		const targetClass = 'team__groups';
		const $targetEl = $('.' + targetClass);

		if (!$targetEl.length) {
			return;
		}

		$targetEl.on('click', '.teamMember', function() {
			if ($(this).hasClass('teamMember--active')) {
				cleanup();
			} else {
				cleanup();
				activate($(this));
			}
		});
		$(window).resize(function() {
			cleanup();
		});
		function cleanup() {
			$targetEl.removeClass(targetClass + '--active');
			$('.teamMember').removeClass('teamMember--active');
			$('.bio').remove();
		}
		function activate(element: JQuery) {
			insertDetail(element);
			$targetEl.addClass(targetClass + '--active');
			element.addClass('teamMember--active');
			element.find('.teamMember__hiddenContent > *').clone().prependTo('.bio');
			$('.bio__close').on('click', function() {
				cleanup();
			});
		}
		function insertDetail(element: JQuery) {
			var detailRow = '<div class="bio"><a class="bio__close">Close Bio</a></div>';

			if (ViewportTracker.below('stackTeamMembers', true)) {
				element.parents('.group').after(detailRow);
			} else {
				$targetEl.after(detailRow);
			}
		}
	}
}